import React from 'react';
import { 
  DialogContent,
  makeStyles,
  FormControl,
  FormLabel,
  DialogActions,
  Button,
  Hidden,
  Radio,
  RadioGroup,
  FormControlLabel
} from '@material-ui/core';
import { ideaCreateActions, ideaCreateDialogsActions } from '../../actions';
import { DialogCustomTitle } from './DialogCustomTitle';
import { DialogCreateIdea } from './DialogCreateIdea';
import { dialogCss } from './dialogCss';

import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from '../../hooks';
import { returnPage } from '../../helpers';
import { useForm } from 'react-hook-form';
import config from '../../config';
import clsx from 'clsx';

function DialogRadicalIdea() {
  const classes = useDispatch();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [width] = useWindowSize();
  const dialogClasses = dialogCss();
  const { handleSubmit, register } = useForm();
  const { methodology } = useSelector((state) => state.domains);
  const { radicals } = useSelector((state) => state.ideaCreate);
  const { dialogRadicalIdea, from } = useSelector((state) => state.ideaCreateDialogs);

  function createDraft() {
    if (radicals.length > 0) {
      dispatch(ideaCreateActions.createDraft(radicals));
    }
  }

  function previous() {
    returnPage(dispatch, from);
  }

  function onSubmit() {
    if (from === 'sendIdea') {
      dispatch(ideaCreateDialogsActions.openDialogSendIdea());
      return;
    }
    dispatch(ideaCreateDialogsActions.openDialogAmbit('DIALOG_RADICAL')); 
  }

  function close() {
    if (width < config.RESPONSIVE_MOBILE) {
      dispatch(ideaCreateDialogsActions.openDialogClose());
    } else {
      dispatch(ideaCreateActions.clear());
      dispatch(ideaCreateDialogsActions.close());
    }
  }

  function selectedAmbit(methodology) {
    dispatch(ideaCreateActions.setRadicalIdea(methodology));
  }

  return(
    <DialogCreateIdea open={dialogRadicalIdea}>
      <DialogCustomTitle id="customized-dialog-title" onClose={close}>
        {t('como_voce_classifica_a_sua_idea')}
      </DialogCustomTitle>
      <DialogContent dividers className={classes.dividerBottom}>
        <FormControl component="fieldset" className={classes.formControl}>
          <FormLabel component="legend" className={dialogClasses.subtitle}>
            {t('selecione_como_a_sua_idea_deve_ser_classificada')}
          </FormLabel>
          <RadioGroup aria-label="methodology" name="methodology">
            {methodology &&
              methodology.map((methodologies) => (
                <FormControlLabel
                  key={methodologies._id}
                  value={methodologies._id}
                  className={clsx(classes.label, dialogClasses.label)}
                  control={<Radio color="secondary" />}
                  onChange={() => selectedAmbit(methodologies)}
                  label={methodologies.name}
                  inputRef={register}
                  checked={radicals?._id === methodologies?._id}
                />
              ))
            }
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions className={dialogClasses.containerAction}>
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div>
            {from && (
              <Button
                color="primary"
                onClick={previous}
                startIcon={<ArrowBackIcon />}
                className={dialogClasses.button}
              >
                {t('voltar')}
              </Button>
            )}
          </div>
          <div>
            <Hidden smDown>
              <Button
                className={dialogClasses.button}
                variant="outlined"
                color="primary"
                style={{ marginRight: 8 }}
                onClick={createDraft}
              >
                {t('salvar_rascunho')}
              </Button>
            </Hidden>
            <Button
              className={dialogClasses.button}
              variant="contained"
              type="submit"
              color="primary"
              startIcon={<ArrowForwardIcon />}
              onClick={handleSubmit(onSubmit)}
            >
              {t('avancar')}
            </Button>
          </div>
        </div>
      </DialogActions>
    </DialogCreateIdea>
  );
}

export { DialogRadicalIdea };